import { navigate } from "gatsby";

/* eslint-disable import/prefer-default-export */
function safeNavigateBack() {
  if (!window || !window.history) {
    throw new Error("Window is not defined.");
  }

  if (!document) {
    throw new Error("Document is not defined.");
  }

  if (document.referrer === "") {
    window.history.go(-1);
  } else {
    navigate("/");
  }
}

export { safeNavigateBack };
